'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import AMLMonitoring from './components/AMLMonitoring';

export default function AMLMonitoringPage() {
  return (
    <AppLayout portalRole="compliance">
      <AMLMonitoring />
    </AppLayout>
  );
}
